import PrinterService from '../services/PrinterService';

// Uncomment the line below for Android builds
// import RNFS from 'react-native-fs';

import Config from "../config/Config";

const PRINT_SIGNATURE = "-- Powered by PedSeguro --";
const config = new Config();

export default class PrintOrderService {

    printLine = (printerService) => {
        printerService.sendPrinterText("---------------------------------", "Centralizado", false, false, "Font A", 0);
        printerService.jumpLine(1);
    }

    printOrder = async (printerService, order) => {
        const logoFileName = config.BUILD_PRODUCT === config.CONTROL_CENTER_ELGINPAY ? config.HEADER_LOGO_FILE_ELGINPAY : config.HEADER_LOGO_FILE_M10;
        const logoImage = await RNFS.readFileRes(logoFileName, "base64");

        printerService.sendPrinterImage(logoImage, true);
        printerService.sendPrinterText(config.CUSTOMER_NAME, "Centralizado", true, false, "Font A", 1);
        printerService.jumpLine(1);
        // text, textAlign, isBold, isUnderline, fontFamily, fontSize
        printerService.sendPrinterText(config.CUSTOMER_ADDRESS, "Centralizado", true, false, "Font A", 0);
        printerService.jumpLine(1);
console.log("order: ", order);
        if (order.print_type === 'CANCEL') {
            this.printLine(printerService);
            printerService.sendPrinterText('*** PEDIDO CANCELADO ***', "Centralizado", true, false, "Font A", 1);
            printerService.jumpLine(1);
        }
        if (order.status === 'completed') {
            this.printLine(printerService);
            printerService.sendPrinterText('*** PEDIDO PAGO ***', "Centralizado", true, false, "Font A", 1);
            printerService.jumpLine(1);
        }
        this.printLine(printerService);
        printerService.sendPrinterText(order.address.first_name, "Esquerda", true, false, "Font A", 1);
        printerService.jumpLine(1);
        printerService.sendPrinterText("MESA " + order.address.last_name, "Esquerda", true, false, "Font A", 1);
        printerService.jumpLine(1);
        printerService.sendPrinterText(order.order_date.date, "Esquerda", false, false, "Font B", 1);
        printerService.jumpLine(1);
        printerService.sendPrinterText("#" + order.order_id, "Esquerda", true, false, "Font A", 1);
        printerService.jumpLine(1);
        this.printLine(printerService);
        if (order.print_type === 'ORDER') {
            order.items.forEach(cartProduct => {
                let itemName = cartProduct.fullName ?? cartProduct.name;
                if (!itemName) {
                    itemName = cartProduct.description;
                }
                printerService.sendPrinterText(cartProduct.quantity.toFixed(0) + " x " + itemName, "Esquerda", true, false, "Font A", 1);
                printerService.jumpLine(1);    
            });
            this.printLine(printerService);
        }
        if (order.customer_note && order.customer_note.length > 0) {
            printerService.sendPrinterText(order.customer_note, "Esquerda", true, false, "Font B", 1);
            printerService.jumpLine(1);    
            this.printLine(printerService);
        }
        printerService.sendPrinterText(PRINT_SIGNATURE, "Centralizado", true, false, "Font B", 0);
        if (config.BUILD_PRODUCT === config.CONTROL_CENTER_ELGINPAY) {
            printerService.jumpLine(5);
        } else {
            printerService.cutPaper(5);
        }
    }

    printProductionItems = async (printerService, order, cart) => {
        printerService.jumpLine(1);
        printerService.jumpLine(1);
        if (order.print_type === 'CANCEL') {
            this.printLine(printerService);
            printerService.sendPrinterText("*** PEDIDO CANCELADO ***", "Centralizado", true, false, "Font A", 1);
            printerService.jumpLine(1);
            this.printLine(printerService);
        }
        printerService.sendPrinterText(order.address.first_name, "Esquerda", true, false, "Font A", 1);
        printerService.jumpLine(1);
        printerService.sendPrinterText("MESA " + order.address.last_name, "Esquerda", true, false, "Font A", 1);
        printerService.jumpLine(1);
        printerService.sendPrinterText(order.order_date.date, "Esquerda", false, false, "Font B", 1);
        printerService.jumpLine(1);
        printerService.sendPrinterText("#" + order.order_id, "Esquerda", true, false, "Font A", 1);
        printerService.jumpLine(1);
        this.printLine(printerService);
        if (order.print_type === 'ORDER') {
            cart.forEach(cartProduct => {
                let itemName = cartProduct.fullName ?? cartProduct.name;
                if (!itemName) {
                    itemName = cartProduct.description;
                }
                printerService.sendPrinterText(cartProduct.quantity.toFixed(0) + " x " + itemName, "Esquerda", true, false, "Font A", 1);
                printerService.jumpLine(1);    
            });
            this.printLine(printerService);
        }
        if (order.customer_note && order.customer_note.length > 0) {
            printerService.sendPrinterText(order.customer_note, "Esquerda", true, false, "Font B", 1);
            printerService.jumpLine(1);    
            this.printLine(printerService);
        }
        if (config.BUILD_PRODUCT === config.CONTROL_CENTER_ELGINPAY) {
            printerService.jumpLine(5);
        } else {
            printerService.cutPaper(5);
        }
    }

    printIfoodOrder = async (printerService, order) => {
        const logoFileName = config.BUILD_PRODUCT === config.CONTROL_CENTER_ELGINPAY ? config.HEADER_LOGO_FILE_ELGINPAY : config.HEADER_LOGO_FILE_M10;
        const logoImage = await RNFS.readFileRes(logoFileName, "base64");

        printerService.sendPrinterImage(logoImage, true);
        printerService.sendPrinterText(config.CUSTOMER_NAME, "Centralizado", true, false, "Font A", 1);
        printerService.jumpLine(1);
        // text, textAlign, isBold, isUnderline, fontFamily, fontSize
        printerService.sendPrinterText(config.CUSTOMER_ADDRESS, "Centralizado", true, false, "Font A", 0);
        printerService.jumpLine(1);
console.log("order: ", order);
        
        this.printLine(printerService);
        printerService.sendPrinterText('*** IFOOD: NOVO PEDIDO ***', "Centralizado", true, false, "Font A", 1);
        this.printLine(printerService);

        printerService.sendPrinterText(order.customer_name, "Esquerda", true, false, "Font A", 1);
        printerService.jumpLine(1);
        printerService.sendPrinterText(order.address, "Esquerda", true, false, "Font A", 1);
        printerService.jumpLine(1);
        printerService.sendPrinterText("#" + order.order_id, "Esquerda", true, false, "Font A", 1);
        printerService.jumpLine(1);
        this.printLine(printerService);

        printerService.sendPrinterText(PRINT_SIGNATURE, "Centralizado", true, false, "Font B", 0);
        if (config.BUILD_PRODUCT === config.CONTROL_CENTER_ELGINPAY) {
            printerService.jumpLine(5);
        } else {
            printerService.cutPaper(5);
        }
    }

    printOrderInfo = async (printersList, order) => {
        let servicePrinter = null;
        switch (order.print_type) {
            case 'ORDER':
            case 'CANCEL':
                servicePrinter = printersList.find(thePrinter => thePrinter.place === 'service');
                if (servicePrinter) {
                    const printerService = new PrinterService();
                    switch(servicePrinter.type) {
                        case 'internal':
                            if (config.BUILD_PRODUCT === config.CONTROL_CENTER_ELGINPAY) {
                                await printerService.sendStartConnectionPrinterElginPay();
                            } else {
                                await printerService.sendStartConnectionPrinterIntern();
                            }
                            break;
                        case 'tcpip':
                            await printerService.sendStartConnectionPrinterExtern(servicePrinter.address, 9100);
                            break;
                    }
                    await this.printOrder(printerService, order);
                    await printerService.printerStop();

                    for (placePrinter of order.printers_list) {
                        const productionPrinter = printersList.find(thePrinter => thePrinter.place === placePrinter.printer);
                        if (productionPrinter) {
                            let printerService = new PrinterService();
                            switch(productionPrinter.type) {
                                case 'internal':
                                    if (config.BUILD_PRODUCT === config.CONTROL_CENTER_ELGINPAY) {
                                        await printerService.sendStartConnectionPrinterElginPay();
                                    } else {
                                        await printerService.sendStartConnectionPrinterIntern();
                                    }
                                    break;
                                case 'tcpip':
                                    await printerService.sendStartConnectionPrinterExtern(productionPrinter.address, 9100);
                                    break;
                            }
                            await this.printProductionItems(printerService, order, placePrinter.items);
                            await printerService.printerStop();
                        }
                    }
                }
                break;
            case 'IFOOD':
                servicePrinter = printersList.find(thePrinter => thePrinter.place === 'service');
                if (servicePrinter) {
                    const printerService = new PrinterService();
                    switch(servicePrinter.type) {
                        case 'internal':
                            if (config.BUILD_PRODUCT === config.CONTROL_CENTER_ELGINPAY) {
                                await printerService.sendStartConnectionPrinterElginPay();
                            } else {
                                await printerService.sendStartConnectionPrinterIntern();
                            }
                            break;
                        case 'tcpip':
                            await printerService.sendStartConnectionPrinterExtern(servicePrinter.address, 9100);
                            break;
                    }
                    await this.printIfoodOrder(printerService, order);
                    await printerService.printerStop();
                }
                break;
        }
    }

    printBill = () => {
        const extPrinterIp = "192.168.0.210";
        printerService.sendStartConnectionPrinterExtern(extPrinterIp, 9100);
        printerService.jumpLine(1);
        cart.forEach(cartProduct => {
            const itemName = cartProduct.fullName ?? cartProduct.name;
            printerService.sendPrinterText(cartProduct.quantity + " x " + itemName, "Esquerda", true, false, "Font A", 1);
        });
        printerService.jumpLine(1);
        printerService.cutPaper(10);
        printerService.printerStop();
    }

}